// extracted by mini-css-extract-plugin
export default {"loader":"signin-redirect_loader__d9HD3"};